import { AuthApi } from "../../Api";

import {
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  WorkshopLogin,
} from "../../Constants";

function requestLogout() {
  return {
    type: LOGOUT_REQUEST,
    isFetching: true,
  };
}

function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS,
    isFetching: false,
    isAuthenticated: false,
    ssoId: null,
  };
}

function logoutError(errorMessage) {
  return {
    type: LOGOUT_FAILURE,
    isFetching: false,
    errorMessage,
  };
}

export const logoutUser = (payload) => (dispatch) => {
  dispatch(requestLogout());
  AuthApi.logout(payload)
    .then((res) => {
      if (res.Error_cd === "SUCCESS") {
        localStorage.clear();
        window.location.href = WorkshopLogin;

        dispatch(logoutSuccess());
        window.location.href = WorkshopLogin;
      } else {
        throw new Error(res.reason);
      }
    })
    .catch((err) => {
      dispatch(logoutError(err));
    });
};